import {
  BadgeEuro,
  Boxes,
  ClipboardCheck,
  Construction,
  Fan,
  Flag,
  Hammer,
  ListChecks,
  Package,
  PlugZap,
  Ruler,
  Sun,
  Truck,
  Warehouse,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

/**
 * Les icônes qu'on peut donner à une étape de la chaîne. Le nom est rangé en
 * base ; ne pas renommer une entrée sans migrer les étapes qui la portent.
 */
export const ICONES = [
  { id: 'camion', libelle: 'Camion', icone: Truck },
  { id: 'colis', libelle: 'Colis', icone: Package },
  { id: 'palettes', libelle: 'Palettes', icone: Boxes },
  { id: 'soleil', libelle: 'Soleil', icone: Sun },
  { id: 'batiment', libelle: 'Bâtiment', icone: Warehouse },
  { id: 'chantier', libelle: 'Chantier', icone: Construction },
  { id: 'marteau', libelle: 'Marteau', icone: Hammer },
  { id: 'plan', libelle: 'Plan', icone: Ruler },
  { id: 'ventilateur', libelle: 'Ventilateur', icone: Fan },
  { id: 'electricite', libelle: 'Électricité', icone: PlugZap },
  { id: 'outil', libelle: 'Outil', icone: Wrench },
  { id: 'controle', libelle: 'Contrôle', icone: ClipboardCheck },
  { id: 'drapeau', libelle: 'Drapeau', icone: Flag },
  { id: 'euro', libelle: 'Euro', icone: BadgeEuro },
] as const satisfies readonly { id: string; libelle: string; icone: LucideIcon }[];

/** L'icône d'une étape ; une liste à cocher si le nom est inconnu. */
export function iconeEtape(nom: string): LucideIcon {
  return ICONES.find((i) => i.id === nom)?.icone ?? ListChecks;
}
